import React from 'react';
import { useSelector } from 'react-redux';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import FileUploaderMC from '../../../components/FileUploaderMC';
import TemplateEditorMC from '../../../components/TemplateEditorMC';
import TitleMC from '../../../components/TitleMC';

const Step3Partial = ({ selectedTemplate, methods }) => {
  const { t } = useTranslation('createCampaign');
  const { current_retailer } = useSelector(
    (reduxState) => reduxState.createCampaignReducer
  );

  const { setValue } = useFormContext();

  const customer_columns_list = current_retailer?.catalogs?.customer_columns_list?.map(([name, value]) => ({
    name,
    value: `{{${value}}}`
  }));

  return (
    <div className="tw-wrapper">
      <div id="step-2">
        <TitleMC text={t('step3.title')} variant="BASE" />
        <div className="tw-text-body tw-pb-6">
          {t('step3.description')}
        </div>
        <TemplateEditorMC
          name="params_template"
          template={selectedTemplate ? selectedTemplate.text : ''}
          options={customer_columns_list}
        />
        {selectedTemplate?.templateType !== 'text' && (
          <div className="tw-pt-6">
            <FileUploaderMC
              name="file"
              label={t('step3.uploadFile')}
              id="file"
              acceptedFileTypes={['image/jpg', 'image/png', 'application/pdf', 'image/jpeg', 'video/mp4']}
              onFileSelect={(file) => {
                setValue('file', file);
              }}
              buttonVariant="SECONDARY"
              defaultFile={methods.getValues('file')}
              preview
            />
          </div>
        )}
      </div>
    </div>
  );
};
export default Step3Partial;
